import React, { useEffect, useRef } from "react";
import { isEqual } from "lodash";
import fieldPropTypes from "../field-prop-types";
import { fieldValidation as validation } from "../../utils/field-validation";
import { FIELD_PARAMS, FIELD_NAMES } from "../../utils/constants";
import { idCreator } from "../../utils/id-creator";
import ModernizedInlineMessage from "./modernized-inline-message";

const ModernizedPhoneNumber = props => {
  const wrapperRef = useRef(null);
  useEffect(() => {
    resetFieldValidationn();
  }, []);

  useEffect(() => {
    const { field, appData, value } = props;
    updateControlValidation(field, appData, value);
  }, [props]);

  const updateControlValidation = (field, appData) => {
    const isFieldVisible =
      !appData.assesmentsState[field.name] ||
      appData.assesmentsState[field.name].visible;

    if (isFieldVisible) {
      validation[field.type].update(field, appData, {
        fieldRef: wrapperRef
      });
    }
  };

  const resetFieldValidationn = (value, isSelect) => {
    const { name } = props.field;
    const {
      resetFieldValidation,
      resetFieldValidationAll,
      isPulse,
      isEnhancedRedesign,
      isUnifiedRegistration
    } = props.appData;
    resetFieldValidation(name);
    const shouldResetAllErrors =
      isSelect &&
      (isEnhancedRedesign || isPulse || isUnifiedRegistration) &&
      name === FIELD_NAMES.searchBy &&
      value !== props.value;
    if (shouldResetAllErrors) {
      resetFieldValidationAll();
    }
  };

  const updateValueObject = (name, value) => {
    const {
      appData: { values, resetFieldValidation, handleChange }
    } = props;
    if (!isEqual(value, values[name])) {
      resetFieldValidation(name);
      handleChange({ [name]: value });
    }
  };

  const isInvalid = () => {
    const { name } = props.field;
    const { fieldValidation } = props.appData;
    return fieldValidation[name] && !fieldValidation[name].isValid;
  };

  const renderField = () => {
    return renderModernizedPhoneInput();
  };
  const {
    components,
    appData: { values },
    field: { name, label, placeholder, params, data, defaultCountry }
  } = props;
  const { ModernizedPhoneInput } = components;
  const renderModernizedPhoneInput = () => {
    return (
      <ModernizedPhoneInput
        id={modernizedInputId}
        labelId={modernizedLabelId}
        placeholder={placeholder}
        components={components}
        name={name}
        data={data}
        label={label}
        defaultCountry={defaultCountry}
        params={params}
        values={values}
        onUpdate={updateValueObject}
        isInvalid={isInvalid()}
      />
    );
  };

  const {
    // components,
    appData,
    field: {
      // name,
      // label,
      helperText,
      // params,
      accessibility = {},
      required
    }
  } = props;
  const { label: textLabel } = accessibility;
  const { modernizedLabelId, modernizedInputId } = idCreator(name);
  const { ModernizedLabel } = components;
  const isRequired = required;
  const isinvalid = isInvalid();
  const errors = props.appData.fieldValidation?.[name];
  const { errorMessage } = props.appData.fieldValidation?.[name] ?? {};
  const visibilityClass = params.includes(FIELD_PARAMS.fieldOptionHidden)
    ? "hidden-field"
    : "";
  const concatErrorMessages =
    isinvalid && !errorMessage && !errors
      ? errors.reduce(
          (error, error_message) => `${error_message + error.errorMessage} `
        )
      : errorMessage;
  const variants = {
    error: "ic_pulse_error_default",
    warning: "ic_pulse_alert_default"
  };
  return (
    <div
      className={`modernized-field-wrapper-web-sdk modernized-phone-number-${name} ${visibilityClass}`}
      ref={wrapperRef}
    >
      <ModernizedLabel
        name={name}
        id={modernizedLabelId}
        inputId={modernizedInputId}
        text={label}
        isRequired={isRequired}
        params={params}
        invalid={isinvalid}
        appData={appData}
        srLabel={textLabel}
        helperText={helperText}
      />
      {renderField()}
      {isinvalid && (
        <ModernizedInlineMessage
          field={{
            image: variants.error,
            title: !errorMessage ? concatErrorMessages : errorMessage
          }}
          components={components}
        >
          {isinvalid && errors && !errorMessage
            ? errors.map(error => error.errorMessage)
            : errorMessage}
        </ModernizedInlineMessage>
      )}
    </div>
  );
};

ModernizedPhoneNumber.propTypes = fieldPropTypes;

export default ModernizedPhoneNumber;
